/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-useless-escape */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BASE_IMAGE_PATH_NEW } from '../../configs/api';
import { SPLASHVIDEOURL } from '../../configs/casinoShowList';
import * as utilService from '../../services/utilService';

let showCloseButtonTimeOut;
class SplashVideoScreenModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            videoLink: '',
            showCloseButton: true,
            mediaType: '',
            imgWidht: 0,
            imgHeight: 0,
            redirecturl: '',
            imgOrientation: 0,
            imgOrnt: 'PORTRAIT',
            loader: false,
            width: document.documentElement.clientWidth
        };
    }
    componentDidMount() {
        this.setState({
            loader: true
        },()=>{
            this.getSplashPopupListJson();
        })
        localStorage.setItem('videoSplashScreenVisited',true);
        // showCloseButtonTimeOut = setTimeout(()=>{
        //     clearTimeout(showCloseButtonTimeOut);
        //     this.setState({showCloseButton:true});
        // },15000);
    }
    componentWillUnmount(){
        clearTimeout(showCloseButtonTimeOut);
    }

    getSplashPopupListJson(){
        const self = this;
        utilService.getSplashPopupListJson().then((res) => {
            if (!!res) {
                const splobj = 'ADMIN';//'CLIENT' ADMIN;
                self.setState({
                    videoLink: res[splobj].mediaType === 'IMAGE'? (this.state.width > 768 ? res[`${splobj}DESKTOP`].url : res[splobj].url ) : res[splobj].url,
                    mediaType: res[splobj].mediaType,
                    redirecturl: res[splobj].redirecturl,
                    imgOrnt: res[splobj].mediaType === 'IMAGE'? (this.state.width > 768 ? res[`${splobj}DESKTOP`].orientation : res[splobj].orientation ) : '',
                },()=>{
                    if(this.state.mediaType === 'IMAGE'){
                        const img = new Image();
                        img.onload = () => {
                            self.setState({
                                imgWidht: img.width,
                                imgHeight: img.height,
                                imgOrientation: img.width > img.height ? -1 : (img.width < img.height ? 1 : 0),
                                loader: false
                            });
                        };
                        img.src = this.state.videoLink;
                    } else {
                        self.setState({
                            loader: false
                        })
                    }
                })
                // self.setState({
                //     jsonData: res,
                //     mediaType : "",
                //     redirecturl : "",
                //     url : "",
                //     imageSrc: "",
                //     imageSrcType: "",
                //     imageSrcFileName: "",
                // },()=>{
                //     self.sideChange(side === '' ? 'ADMIN' : side);
                // })
            } else {
                self.setState({
                    loader: false
                })
            }
        });
    }
    
    hidePopup(){
        this.props.hidePopup()
    }
    
    render() {       
        
        return (
            <>
                <div id="splashscreenmodalpopup" className={`modal fade show sign-up-form depositpopup ${this.state.mediaType === 'VIDEO' ? "videosplashpopup": ( this.state.imgOrientation === -1 ? 'horizontalsplashpopup' : '')}`} style={{ display: "block" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                <div className={`modal-dialog modal-dialog-centered ${ this.state.mediaType === 'IMAGE' ? (this.state.imgOrnt === 'SQUARE' ? 'square-popup' : (this.state.imgOrnt === 'LANDSCAPE' ? 'landscape-popup' : '')): ''}`} >
                        <div className="modal-content hebebox b-0">
                        {/* {this.state.showCloseButton && 
                            <div className="modal-header">
                                <button onClick={() => { this.hidePopup() }} type="button" className="close text-black btncloseset" data-dismiss="modal" aria-hidden="true">×</button>
                            </div>
                        } */}
                            <div className="modal-body p-0" id='content'>
                                {this.state.loader ? 
                                    <div className='splashloader'>
                                        <img className='' src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/l.gif`} alt=''></img>
                                    </div>
                                    :
                                    <>
                                        {(this.state.mediaType === 'VIDEO' && !this.state.loader) && 
                                            <div className='vimeo-iframe-parent-div'>
                                                {this.state.showCloseButton && 
                                                    <button onClick={() => { this.hidePopup() }} type="button" className="close  btncloseset" data-dismiss="modal" aria-hidden="true">×</button>
                                                }
                                                <iframe id='ifrmSplashScreenModal' className='vimeo-iframe' src={SPLASHVIDEOURL} frameBorder="0" allow="autoplay;"></iframe>

                                            </div>
                                        }
                                        {(this.state.mediaType === 'IMAGE' && !this.state.loader) && 
                                            <div className='splash-image-parent-div'>
                                            {this.state.showCloseButton && 
                                                    <button onClick={() => { this.hidePopup() }} type="button" className="close  btncloseset" data-dismiss="modal" aria-hidden="true">×</button>
                                            }
                                            {!!this.state.redirecturl && this.state.redirecturl !== '' ?
                                                <a href={this.state.redirecturl} target="_blank" rel="noreferrer">
                                                    <img className='splash-image-img' src={this.state.videoLink} alt=''></img>
                                                </a>
                                                :
                                                <img className='splash-image-img' src={this.state.videoLink} alt=''></img>
                                            }
                                            </div>
                                        }
                                    </>
                                }       

                               

                                

                                {/* <script src="https://player.vimeo.com/api/player.js"></script> */}
                            </div>                            
                        </div>
                    </div>
                    <div className="modal-backdrop fade show"></div> 
                    {/* onClick={() => { this.props.hidePopup() }} */}
                </div>
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(SplashVideoScreenModal);
